import { render, staticRenderFns } from "./UserParamManager.vue?vue&type=template&id=4c616c40&scoped=true&"
import script from "./UserParamManager.vue?vue&type=script&lang=js&"
export * from "./UserParamManager.vue?vue&type=script&lang=js&"
import style0 from "./UserParamManager.vue?vue&type=style&index=0&id=4c616c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c616c40",
  null
  
)

export default component.exports